import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = [
  {
    label: "Utilizador",
    name: "id_utilizador",
    type: "array",
    store: "utilizador",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    type: "deusangue",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Utilizador",
    align: "left",
    value: "utilizador"
  },
  {
    text: "Hora",
    align: "left",
    value: "hora"
  },
  {
    text: "Deu sangue?",
    align: "left",
    value: "estado"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const UTILIZADOR_COLHEITA = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default UTILIZADOR_COLHEITA
